import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import DisasterRecoveryTab from './ZPA/disaster-recovery';
import UpdateAppSegmentTab from './ZPA/update-app-segment';
import PseTab from './ZPA/pse';
import ListIDPs from './ZPA/download-scim-groups';
import DownloadScimGroups from './ZPA/download-scim-groups';
import PolicyGroupMigration from './ZPA/policy-group-migration';

function ZPATab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab, setSelectedTab, setZPASelectedTab }) {
    function onTabSelect(eventKey) {
        setSelectedTab(eventKey);
        setZPASelectedTab(eventKey);
    }
    return (

        <Tab.Container id="ZPA" defaultActiveKey="disasterRecovery" on>
            <Nav fill variant="pills" justify className=' bg-dark-subtle justify-content-center rounded-2' onSelect={(eventKey) => onTabSelect(eventKey)}>
                <Nav.Item>
                    <Nav.Link eventKey="disasterRecovery">Disaster Recovery</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="pse">PSE</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="updateAppSegment">Update App Segment</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="downloadScimGroups">Download SCIM Groups</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="policyGroupMigration">Policy Group Migration</Nav.Link>
                </Nav.Item>

            </Nav>
            <Tab.Content>
                <Tab.Pane eventKey="disasterRecovery">
                    <DisasterRecoveryTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="updateAppSegment">
                    <UpdateAppSegmentTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="pse">
                    <PseTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="downloadScimGroups">
                    <DownloadScimGroups groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="policyGroupMigration">
                    <PolicyGroupMigration groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>

    );
}

export default ZPATab;